// src/lib/constants.js
// ─────────────────────────────────────────────────────────
// Shared defaults. Components import from here, not hardcode.
// ─────────────────────────────────────────────────────────

export const DEFAULT_TRANSACTION_TYPES = {
  expense:   { label: 'Expense (Outflow) -', type: 'outflow' },
  income:    { label: 'Income (Inflow) +',   type: 'inflow' },
  liability: { label: 'Loan/Liability',      type: 'liability' },
};

export const DEFAULT_CATEGORIES = {
  income: ['Sales', 'Service Revenue', 'Owner Equity', 'Grant', 'Other Income'],
  expense: [
    'Preliminaries', 'Substructure', 'Frames', 'Roof',
    'Finishes', 'MEP', 'VAT & Contingency', 'Other',
  ],
  liability: ['Loan Repayment', 'Debt Service', 'Accounts Payable', 'Other Liability'],
};

export const LEGACY_TYPE_ALIASES = {
  disbursement: 'income',
  funding: 'income',
  loan_funding: 'income',
  revenue: 'income',
};

export const normalizeTransactionTypeKey = (rawType, availableTypes = DEFAULT_TRANSACTION_TYPES) => {
  const value = String(rawType || '').trim().toLowerCase();
  if (!value) return 'expense';
  const canonical = LEGACY_TYPE_ALIASES[value] || value;
  if (availableTypes[canonical]) return canonical;
  if (DEFAULT_TRANSACTION_TYPES[canonical]) return canonical;
  return 'expense';
};

export const resolveTransactionTypeConfig = (rawType, availableTypes = DEFAULT_TRANSACTION_TYPES) => {
  const key = normalizeTransactionTypeKey(rawType, availableTypes);
  return {
    key,
    ...(availableTypes[key] || DEFAULT_TRANSACTION_TYPES[key] || DEFAULT_TRANSACTION_TYPES.expense),
  };
};

export const getTransactionImpactSign = (rawType, availableTypes = DEFAULT_TRANSACTION_TYPES) =>
  resolveTransactionTypeConfig(rawType, availableTypes).type === 'inflow' ? 1 : -1;

export const SORT_OPTIONS = [
  { value: 'date-desc',   label: 'Newest First'         },
  { value: 'date-asc',    label: 'Oldest First'          },
  { value: 'amount-desc', label: 'Amount (High to Low)'  },
  { value: 'amount-asc',  label: 'Amount (Low to High)'  },
];

export const REPORT_TYPES = [
  { id: 'balance-sheet',     label: 'Balance Sheet'           },
  { id: 'income-statement',  label: 'Income Statement'        },
  { id: 'cash-flow',         label: 'Cash Flow'               },
  { id: 'equity',            label: "Shareholders' Equity"    },
];

export const formatCurrency = (v) =>
  new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(isNaN(v) ? 0 : v);

export const formatAccounting = (v) =>
  v < 0 ? `(${formatCurrency(Math.abs(v))})` : formatCurrency(v);
